import { useContext } from "react";
import LocationHistoryContext from "contexts/LocationHistoryContext";

const useLocationHistory = () => {
  return useContext(LocationHistoryContext);
};

export default useLocationHistory;
